var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "white" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 pt-6" },
        [
          _c(
            "v-col",
            { staticClass: "pl-0", attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("img", {
                        staticClass: "arrow px-4 py-3",
                        attrs: { src: _vm.ic_back, id: "back-btn" },
                        on: { click: _vm.backToPrevPage },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-n4", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "back-lbl" }, [
                        _vm._v("Back to Quotes "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.quote
        ? _c(
            "v-row",
            {
              staticClass: "mt-n2 admin-shipment-details",
              attrs: { justify: "center" },
            },
            [
              _c(
                "v-col",
                { attrs: { cols: "10" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mt-7",
                          attrs: {
                            xs11: "",
                            sm11: "",
                            md11: "",
                            lg11: "",
                            xl11: "",
                          },
                        },
                        [
                          _c("span", { staticClass: "details-page-header" }, [
                            _vm._v("Quote Details"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mb-3", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "auto" } }, [
                        _c("label", { staticClass: "client-name" }, [
                          _vm._v(_vm._s(_vm.quote.company)),
                        ]),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "mt-n2 px-0", attrs: { cols: "auto" } },
                        [_c("img", { attrs: { src: _vm.ic_dot_black } })]
                      ),
                      _c("v-col", { attrs: { cols: "auto" } }, [
                        _c("label", { staticClass: "shipment-id" }, [
                          _vm._v(" " + _vm._s(_vm.id) + " "),
                          _c("img", {
                            staticClass: "ml-1 copy",
                            attrs: {
                              src: _vm.ic_copy,
                              title: "Copy to Clipboard",
                            },
                            on: { click: _vm.copy },
                          }),
                        ]),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "mt-n2 px-0", attrs: { cols: "auto" } },
                        [_c("img", { attrs: { src: _vm.ic_dot_black } })]
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-chip",
                            {
                              staticClass: "status",
                              attrs: { color: "#7FC4FD" },
                            },
                            [_vm._v(" ACTIVE QUOTE ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "mt-1 pr-0", attrs: { cols: "auto" } },
                        [
                          _c("img", {
                            staticClass: "orig-pin",
                            attrs: { src: _vm.ic_pin_blue_v2 },
                          }),
                        ]
                      ),
                      _c("v-col", { attrs: { cols: "auto" } }, [
                        _c("label", { staticClass: "stop-name" }, [
                          _vm._v("Origin "),
                        ]),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "mt-1 pr-0", attrs: { cols: "auto" } },
                        [
                          _c("img", {
                            staticClass: "dest-pin",
                            attrs: { src: _vm.ic_pin_blue_v2 },
                          }),
                        ]
                      ),
                      _c("v-col", { attrs: { cols: "auto" } }, [
                        _c("label", { staticClass: "stop-name" }, [
                          _vm._v("Destination "),
                        ]),
                      ]),
                      _c("v-spacer"),
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "hover shipment-control px-4 py-2",
                              attrs: { "no-gutters": "", align: "center" },
                              on: { click: _vm.bookShipment },
                            },
                            [
                              _c("v-col", { attrs: { cols: "auto" } }, [
                                _c("img", {
                                  staticClass: "mt-2",
                                  attrs: { src: _vm.ic_pencil, width: "14px" },
                                }),
                              ]),
                              _c("v-col", { attrs: { cols: "auto" } }, [
                                _c(
                                  "label",
                                  { staticClass: "finish-booking hover" },
                                  [_vm._v("    Finish Booking ")]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "hover shipment-control px-4 py-2",
                              attrs: { "no-gutters": "", align: "center" },
                              on: { click: _vm.emailQuote },
                            },
                            [
                              _c("v-col", { attrs: { cols: "auto" } }, [
                                _c("img", {
                                  staticClass: "mt-2",
                                  attrs: {
                                    src: _vm.ic_mail_blue,
                                    width: "14px",
                                  },
                                }),
                              ]),
                              _c("v-col", { attrs: { cols: "auto" } }, [
                                _c(
                                  "label",
                                  { staticClass: "finish-booking hover" },
                                  [_vm._v("    EMAIL QUOTE ")]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            lg12: "",
                            xl12: "",
                          },
                        },
                        [
                          _c("smart-map-azure", {
                            attrs: {
                              stops: [_vm.origAddress, _vm.destAddress],
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "tabs-group mt-8 mb-10" },
                    [
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-row",
                            _vm._l(_vm.availableTabs, function (tab) {
                              return _c(
                                "v-col",
                                {
                                  key: tab,
                                  staticClass: "details-tab mr-16",
                                  class: { active: _vm.currentTab == tab },
                                  attrs: { cols: "auto" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.tabClicked(tab)
                                    },
                                  },
                                },
                                [_c("label", [_vm._v(_vm._s(tab))])]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.currentTab == "Overview"
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "v-row",
                                    { staticClass: "mt-7" },
                                    [
                                      _c(
                                        "v-col",
                                        [
                                          _c(
                                            "v-row",
                                            { attrs: { align: "center" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "auto" } },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "top-5 carrier-logo",
                                                    attrs: { src: _vm.path },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ml-3",
                                                  attrs: { cols: "auto" },
                                                },
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass: "mt-n2",
                                                      attrs: {
                                                        "no-gutters": "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "carrier-lbl",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.quote
                                                                    .carrierName
                                                                    ? _vm.quote
                                                                        .carrierName
                                                                    : "Not Selected"
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "stops-count",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " 2 stops, 1 delivery "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        [
                                          _c("v-divider", {
                                            staticClass: "eta-divider",
                                            attrs: { inset: "" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "12" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "eta-label" },
                                          [_vm._v("ETA " + _vm._s(_vm.eta))]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ta-c ml-n3",
                                          attrs: { cols: "1" },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "orig-pin",
                                            attrs: { src: _vm.ic_pin_blue_v2 },
                                          }),
                                          _c("br"),
                                          _c("img", {
                                            staticClass: "mt-1",
                                            attrs: { src: _vm.ic_border },
                                          }),
                                          _c("br"),
                                          _c("img", {
                                            staticClass: "dest-pin",
                                            attrs: { src: _vm.ic_pin_blue_v2 },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        [
                                          _c(
                                            "v-row",
                                            { attrs: { "no-gutters": "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "location-name",
                                                    },
                                                    [_vm._v("Origin Location")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { "no-gutters": "" } },
                                            [
                                              _c("v-col", [
                                                _c(
                                                  "label",
                                                  { staticClass: "stop-head" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.quote.origCity +
                                                          ", " +
                                                          _vm.quote.origState +
                                                          " " +
                                                          _vm.quote.origZip +
                                                          " " +
                                                          _vm.quote.origCountry
                                                      ) + " "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { "no-gutters": "" } },
                                            [
                                              _c("v-col", [
                                                _c(
                                                  "label",
                                                  { staticClass: "stop-sub" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.quote.company)
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "mt-125",
                                              attrs: { "no-gutters": "" },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "location-name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Destination Location"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { "no-gutters": "" } },
                                            [
                                              _c("v-col", [
                                                _c(
                                                  "label",
                                                  { staticClass: "stop-head" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.destAddressInline
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { "no-gutters": "" } },
                                            [
                                              _c("v-col", [
                                                _c(
                                                  "label",
                                                  { staticClass: "stop-sub" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.quote.company)
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("v-spacer"),
                              _c(
                                "v-col",
                                { attrs: { cols: "5" } },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "mt-12 br-10",
                                      attrs: { elevation: "1" },
                                    },
                                    [
                                      _c("v-card-text", [
                                        _c(
                                          "div",
                                          { staticClass: "px-5 mt-3" },
                                          [
                                            _c(
                                              "v-row",
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "fl rate-summary-heading",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Rate Cost Summary"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-col",
                                                  { staticClass: "mt-n2" },
                                                  [_c("v-divider")],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-row",
                                              { staticClass: "pr-3" },
                                              [
                                                _c("v-col", [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "fl rate-cost-sub-heading",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Base Transportation Cost"
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("v-col", [
                                                  _vm.base
                                                    ? _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "rate-cost-sub-heading fr",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatMoney(
                                                                _vm.base
                                                              )
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.currency
                                                              )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  !_vm.base
                                                    ? _c("img", {
                                                        staticClass: "fr dots",
                                                        attrs: {
                                                          src: _vm.ic_border_dots_v3,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-row",
                                              { staticClass: "mt-n2 pr-3" },
                                              [
                                                _c("v-col", [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "fl rate-cost-sub-heading",
                                                    },
                                                    [_vm._v("Fuel Surcharge")]
                                                  ),
                                                ]),
                                                _c("v-col", [
                                                  _vm.fuel
                                                    ? _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "rate-cost-sub-heading fr",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatMoney(
                                                                _vm.fuel
                                                              )
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.currency
                                                              )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  !_vm.fuel
                                                    ? _c("img", {
                                                        staticClass: "fr dots",
                                                        attrs: {
                                                          src: _vm.ic_border_dots_v3,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _vm._l(
                                              _vm.additionalCharges,
                                              function (charge) {
                                                return _c(
                                                  "v-row",
                                                  {
                                                    key: charge.accChargeId,
                                                    staticClass: "mt-n2 pr-3",
                                                  },
                                                  [
                                                    _c("v-col", [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "fl rate-cost-sub-heading",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              charge.description
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                    _c("v-col", [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "rate-cost-sub-heading fr",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatMoney(
                                                                charge.sellCharge
                                                              )
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.currency
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            _c(
                                              "v-row",
                                              { staticClass: "mt-4" },
                                              [
                                                _c(
                                                  "v-col",
                                                  [_c("v-divider")],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-row",
                                              { staticClass: "mt-2 mb-1" },
                                              [
                                                _c("v-col", [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "fl shipment-total-lbl",
                                                    },
                                                    [_vm._v("Total ")]
                                                  ),
                                                ]),
                                                _c("v-col", [
                                                  _vm.total
                                                    ? _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "shipment-total-lbl fr",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatMoney(
                                                                _vm.total
                                                              )
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.currency
                                                              )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  !_vm.total
                                                    ? _c("img", {
                                                        staticClass:
                                                          "fr dots mr-3",
                                                        attrs: {
                                                          src: _vm.ic_border_dots_v3,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-divider", { staticClass: "mt-9" }),
                          _c(
                            "v-row",
                            { staticClass: "mt-9" },
                            [
                              _c("v-col", [
                                _c(
                                  "label",
                                  { staticClass: "ship-section-head" },
                                  [_vm._v("Quote Details")]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { staticClass: "mt-5" },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md6: "",
                                    lg4: "",
                                    xl4: "",
                                  },
                                },
                                [
                                  _c("label", { staticClass: "details-lbl" }, [
                                    _vm._v("Mode Type"),
                                  ]),
                                  _c("br"),
                                  _c("label", { staticClass: "details-sub" }, [
                                    _vm._v(_vm._s(_vm.quote.mode)),
                                  ]),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md6: "",
                                    lg4: "",
                                    xl4: "",
                                  },
                                },
                                [
                                  _c("label", { staticClass: "details-lbl" }, [
                                    _vm._v("Distribution Method"),
                                  ]),
                                  _c("br"),
                                  _c("label", { staticClass: "details-sub" }, [
                                    _vm._v(_vm._s(_vm.distributionMethod)),
                                  ]),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md6: "",
                                    lg4: "",
                                    xl4: "",
                                  },
                                },
                                [
                                  _c("label", { staticClass: "details-lbl" }, [
                                    _vm._v("Equipment Type"),
                                  ]),
                                  _c("br"),
                                  _c("label", { staticClass: "details-sub" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.quote.equipmentTypeDesc
                                          ? _vm.quote.equipmentTypeDesc
                                          : "Not Available"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { staticClass: "mt-8" },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md6: "",
                                    lg4: "",
                                    xl4: "",
                                  },
                                },
                                [
                                  _c("label", { staticClass: "details-lbl" }, [
                                    _vm._v("Estimated Pickup"),
                                  ]),
                                  _c("br"),
                                  _c("label", { staticClass: "details-sub" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDate(_vm.quote.createdDate)
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md6: "",
                                    lg4: "",
                                    xl4: "",
                                  },
                                },
                                [
                                  _c("label", { staticClass: "details-lbl" }, [
                                    _vm._v("Estimated Delivery"),
                                  ]),
                                  _c("br"),
                                  _c("label", { staticClass: "details-sub" }, [
                                    _vm._v(_vm._s(_vm.estimatedDeliveryDate)),
                                  ]),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md6: "",
                                    lg4: "",
                                    xl4: "",
                                  },
                                },
                                [
                                  _c("label", { staticClass: "details-lbl" }, [
                                    _vm._v("ETA"),
                                  ]),
                                  _c("br"),
                                  _c("label", { staticClass: "details-sub" }, [
                                    _vm._v(_vm._s(_vm.eta)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { staticClass: "mt-8 mb-2" },
                            [
                              _c("v-col", [
                                _c(
                                  "label",
                                  { staticClass: "ship-section-head" },
                                  [_vm._v("Container Information")]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { staticClass: "ml-1" },
                            [
                              _c("container-details", {
                                attrs: { pieces: _vm.quote.pieces },
                              }),
                            ],
                            1
                          ),
                          _vm.accessorials.length
                            ? _c(
                                "v-row",
                                { staticClass: "mt-12 mb-4" },
                                [
                                  _c("v-col", [
                                    _c(
                                      "label",
                                      { staticClass: "ship-section-head" },
                                      [_vm._v("Additional Services")]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-row",
                            { staticClass: "mt-3" },
                            _vm._l(_vm.accessorials, function (service) {
                              return _c(
                                "v-col",
                                {
                                  key: service.id,
                                  attrs: {
                                    cols: "12",
                                    sm: "12",
                                    md: "6",
                                    lg: "3",
                                    xl: "3",
                                  },
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "shipment-details-checkbox",
                                    attrs: {
                                      readonly: "",
                                      disabled: "",
                                      ripple: false,
                                      label: service.description,
                                    },
                                    model: {
                                      value: _vm.checked,
                                      callback: function ($$v) {
                                        _vm.checked = $$v
                                      },
                                      expression: "checked",
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c(
                            "v-row",
                            { staticClass: "mt-12" },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("smart-btn", {
                                    staticClass: "w-40-pct",
                                    attrs: {
                                      label: "Finish Booking",
                                      type: "primary",
                                      icon: _vm.ic_pencil_white,
                                      "icon-position": "right",
                                      "icon-class": "ml-2",
                                    },
                                    on: { click: _vm.bookShipment },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("smart-btn", {
                                    staticClass: "w-40-pct",
                                    attrs: {
                                      label: "Email Quote",
                                      type: "primary",
                                      icon: _vm.ic_external_track_white,
                                      "icon-position": "right",
                                      "icon-class": "ml-2",
                                    },
                                    on: { click: _vm.emailQuote },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("v-row", { staticClass: "py-6" }),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function (ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "#007BFF", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackbar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _c("img", {
            staticClass: "success-icon",
            attrs: { src: _vm.ic_green_success_checkmark },
          }),
          _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
        ]
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v(_vm._s(_vm.loadingMsg)),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("email-quote", {
        attrs: {
          display: _vm.showEmailQuotePopup,
          emailTemplate: _vm.emailTemplate,
          quote: _vm.emailingQuote,
        },
        on: {
          hide: function ($event) {
            _vm.showEmailQuotePopup = false
          },
          emailSent: _vm.emailSent,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }